import store from 'src/store'

function possuiIntegracaoAutomaticaCadastrosSankhya() {
  const compMan = store.state.userInfo.compMan || {}

  return compMan.possuiIntegracaoAutomaticaCadastrosSankhya === true ||
    compMan.possui_integracao_automatica_cadastros_sankhya === true
}

function possuiFarolDoDp() {
  const compMan = store.state.userInfo.compMan || {}

  return compMan.possuiFarolDoDp === true || compMan.possui_farol_do_dp === true
}

/**
 * Valida se uma permissão ou subpermissão deve ser exibido com base no modulo ou submodulo.
 * @param {string} moduloOuSubmodulo - O identificador da permissão.
 * @returns {boolean} 
 * Utilizar array com modulos que deseja aplicar a regra e retornar a flag ou modulo na store.
 * @example
 * if (['cadastros', 'exportfiles'].includes(moduloOuSubmodulo)) {
 *  return store.state.modulosEFuncionalidades.funcionalidades.acesso_ferramenta_crisp?.enabled
 * }
 * 
 */
export function validarCondicaoShow(moduloOuSubmodulo) {
  if (['segmentacaodevisualizacaojornada', 'segmentacaodevisualizacaoescala'].includes(moduloOuSubmodulo)) {
    return store.state.userInfo.compMan.segmentacaoDeVisualizacao
  }

  if (moduloOuSubmodulo === 'auditoriadeintegracoes') {
    return possuiIntegracaoAutomaticaCadastrosSankhya() ||
      store.state.modulosEFuncionalidades.funcionalidades.acesso_auditoria_de_integracoes?.enabled === true
  }

  if (moduloOuSubmodulo === 'faroldodp') {
    return possuiFarolDoDp()
  }

  return true;
}
